export default "__VITE_ASSET__DtZfCexx__"